import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Gift, Loader2 } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { useToast } from '@/providers/UiProviders'
import { CardBackLink, Body, ActionCard, ReasonInput } from './userActionKit'
import { USERS_STR as S, grantUserReward, isPending } from './usersAdminApi'

/**
 * A3.36 — Premium/Stars berish (kompensatsiya). JONLI `POST /admin/points/grant`
 * ({user_id, amount, reason}) — MyGram'da Stars ekvivalenti = ball iqtisodi.
 * Musbat miqdor = berish, manfiy = yechish. `finance.economy.grant` huquqi bilan
 * gated (serverда majburlanadi — B4/NEW-M1 economy-mint guard).
 */
export function UserReward() {
  const { id = '' } = useParams()
  const userId = Number(id)
  const { toast } = useToast()
  const [amount, setAmount] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)

  const amt = Number(amount)
  const canSubmit = Number.isFinite(amt) && amt !== 0 && reason.trim().length >= 3 && !busy

  const submit = async () => {
    if (!canSubmit) return
    setBusy(true)
    try {
      await grantUserReward(userId, Math.trunc(amt), reason.trim())
      setAmount('')
      setReason('')
      toast(S.rewardGranted, { tone: 'success' })
    } catch (e) {
      if (isPending(e)) toast(S.pending, { tone: 'warning' })
      else toast(S.failed, { tone: 'error', ...(e instanceof Error && e.message ? { description: e.message } : {}) })
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <PageHeader title={S.rewardTitle} screenId="A3.36" actions={<CardBackLink id={id} />} />
      <Body>
        <ActionCard hint={S.rewardHint}>
          <label className="block">
            <span className="mb-1 block text-xs text-tertiary">{S.rewardAmount}</span>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="+100 / -50"
              className="w-40 rounded-md border border-border-default bg-surface-1 px-3 py-1.5 text-sm text-primary outline-none focus:border-border-strong"
            />
          </label>
          <ReasonInput value={reason} onChange={setReason} />
          <button
            onClick={() => void submit()}
            disabled={!canSubmit}
            className="inline-flex items-center gap-1.5 rounded-md bg-accent px-4 py-1.5 text-sm font-medium text-white hover:bg-accent-hover disabled:opacity-50"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Gift size={14} />}
            {S.rewardGrant}
          </button>
        </ActionCard>
      </Body>
    </>
  )
}
